import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		container: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			height: "80%",
		},
	} satisfies Record<string, CSSObject>);
};
